import { MUTATION_LOAD_FONTS } from './mutation-types';

export default {
  [MUTATION_LOAD_FONTS]: (state, fonts) => {
    state.fonts = fonts;
  }
};
